module.exports = __webpack_public_path__ + "static/media/18ECA46.6eee3176.jpg";